<template>
  <div style="background:#fff">
    <div class="aui-book-head" v-if="title">
      <h2>{{title}}</h2>
      <div>
        <a v-if="showRefresh" class="ccc" @click="showRefreshAction">换一批</a>
        <span  v-if="showMore"  @click="showMoreAction" class="more">更多</span>
      </div>
    </div>
    <div class="aui-list-theme">
      <router-link :to="{name: 'book-home', params: {id: book.bookId}}" v-for="book in books" :key="book.bookId"  class="aui-list-theme-item">
        <div class="aui-list-img">
          <!-- <img :src="book.cover | getImgUrl" alt /> -->
          <img :imgpath="getCoverPlaceholder(book.cover)"  v-lazy="require('../../assets/img/loading.jpeg')" alt />
        </div>
        <div class="aui-list-title">
          <h3>{{book.title}}</h3>
          <div class="aui-flex">
            <div class="aui-flex-box">
              <span class="i-a">{{book.categoryName}}</span>
              <span v-if="book.publishStatus==='serialize'" class="i-c">连载中</span>
              <span v-if="book.publishStatus==='finish'" class="i-b">已完结</span>
            </div>
          </div>
        </div>
      </router-link>
      <!-- <router-link :to="{name: 'book-home', params: {id: 1233}}" class="aui-list-theme-item">
        <div class="aui-list-img">
          <img src="../../assets/img/book-book-002.png" alt />
        </div>
        <div class="aui-list-title">
          <h3>法旅之师</h3>
          <div class="aui-flex">
            <div class="aui-flex-box">
              <span class="i-a">都市</span>
              <span class="i-b">9.5分</span>
            </div>
          </div>
        </div>
      </router-link>
      <router-link :to="{name: 'book-home', params: {id: 1233}}" class="aui-list-theme-item">
        <div class="aui-list-img">
          <img src="../../assets/img/book-book-003.png" alt />
        </div>
        <div class="aui-list-title">
          <h3>法旅之师</h3>
          <div class="aui-flex">
            <div class="aui-flex-box">
              <span class="i-a">都市</span>
              <span class="i-b">9.5分</span>
            </div>
          </div>
        </div>
      </router-link>
      <router-link :to="{name: 'book-home', params: {id: 1233}}" class="aui-list-theme-item">
        <div class="aui-list-img">
          <img src="../../assets/img/book-book-004.png" alt />
        </div>
        <div class="aui-list-title">
          <h3>法旅之师</h3>
          <div class="aui-flex">
            <div class="aui-flex-box">
              <span class="i-a">都市</span>
              <span class="i-b">9.5分</span>
            </div>
          </div>
        </div>
      </router-link>

      <router-link :to="{name: 'book-home', params: {id: 1233}}" class="aui-list-theme-item">
        <div class="aui-list-img">
          <img src="../../assets/img/book-book-005.png" alt />
        </div>
        <div class="aui-list-title">
          <h3>法旅之师</h3>
          <div class="aui-flex">
            <div class="aui-flex-box">
              <span class="i-a">都市</span>
              <span class="i-b">9.5分</span>
            </div>
          </div>
        </div>
      </router-link>
      <router-link :to="{name: 'book-home', params: {id: 1233}}" class="aui-list-theme-item">
        <div class="aui-list-img">
          <img src="../../assets/img/book-book-006.png" alt />
        </div>
        <div class="aui-list-title">
          <h3>法旅之师</h3>
          <div class="aui-flex">
            <div class="aui-flex-box">
              <span class="i-a">都市</span>
              <span class="i-b">9.5分</span>
            </div>
          </div>
        </div>
      </router-link> -->
    </div>
  </div>
</template>

<script>
import { getImg } from '../../services/urlService'

export default {
  name: 'books-small',
  props: {
    title: String,
    books: Array,
    showTitle: {
      type: Boolean,
      default: true
    },
    showMore: {
      type: Boolean,
      default: true
    },
    showRefresh: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {}
  },
  methods: {
    toBookDetail (id) {
      this.$router.isBack = false
      this.$router.push(`/book/${id}`)
    },
    getCover (route) {
      return getImg(`${route}_180_0.img`)
    },
    getCoverPlaceholder(route) {
      return `${route}_180_0.img`;
    },
    showMoreAction () {
      this.$emit('show-more')
    },
    showRefreshAction(){
      this.$emit('show-refresh');
    },
    getPublishStatusText (code) {
      if (code === 'finish') {
        return '完结'
      } else {
        return '连载'
      }
    }
  },
  watch: {
    books (data) {}
  }
}
</script>
<style scoped>
.aui-book-head .ccc{padding:0 0.3rem 0 1.3rem; line-height: 1.2rem; height: 1.2rem; font-size: .8rem; border-radius: 1rem; border:1px solid #91174e; display: inline-block;
  background:#fff url(../../assets/img/bg7.png) 0.3rem center no-repeat; background-size: 0.7rem; color: #91174e; margin-right: 20px;}
</style>

